module.exports = __webpack_public_path__ + "static/img/grzj.5494f69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/kpi/grzj.png
// module id = 8zM7
// module chunks = 4